import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';


@Component({
    selector: 'app-pagination',
    templateUrl: './pagination.component.html'
})
export class PaginationComponent implements OnInit {
    @Input() public currentPage = 1;
    @Input() public itemsCount: number;
    @Output() public pageChange: EventEmitter<any> = new EventEmitter<any>();
    public showPrevPage: any;
    public showNextPage: any;

    constructor() {
    }

    ngOnInit() {
        this.setPageShows();

    }

    setPageShows() {
        this.showPrevPage = this.currentPage > 1;
        this.showNextPage = this.currentPage < Math.ceil(this.itemsCount / 3);
    }

    nextPage() {
        this.currentPage = +this.currentPage + 1;
        this.pageChange.emit(this.currentPage);
        this.setPageShows();
    }

    prevPage() {
        this.currentPage = +this.currentPage - 1;
        this.pageChange.emit(this.currentPage);
        this.setPageShows();

    }

}



// WEBPACK FOOTER //
// /home3/usalinks/public_html/ally-book-source/src/app/blog/pagination/pagination.component.ts